import api from "../axios";
import Api from "../Api";

export async function AccountReceivableFindAll(search = "", start = 0, limit = 20) {
  try {
    const response = await api.get(
      `${Api.request.URL}/account-receivables?search=${encodeURIComponent(search || "")}&start=${start || 0}&limit=${limit || 20}`
    );
    return response.data;
  } catch (error) {
    return {
      S: false,
      success: false,
      status: false,
      msg: error?.response?.data?.message || error?.response?.data?.msg || "Unable to load account receivable.",
      errors: error?.response?.data?.errors || error?.message || "Unable to load account receivable.",
      data: [],
      count: 0
    };
  }
}

export async function AccountReceivableFindOne(id) {
  try {
    const response = await api.get(`${Api.request.URL}/account-receivables/${id}`);
    return response.data;
  } catch (error) {
    return {
      S: false,
      success: false,
      status: false,
      msg: error?.response?.data?.message || error?.response?.data?.msg || "Unable to load account receivable details.",
      errors: error?.response?.data?.errors || error?.message || "Unable to load account receivable details."
    };
  }
}

export async function AccountReceivableCreatePayment(data) {
  try {
    const response = await api.post(
      `${Api.request.URL}/account-receivables/payment`,
      data
    );
    return response.data;
  } catch (error) {
    return {
      S: false,
      success: false,
      status: false,
      msg: error?.response?.data?.message || error?.response?.data?.msg || "Unable to save payment.",
      errors: error?.response?.data?.errors || error?.message || "Unable to save payment."
    };
  }
}
